$('.orders .item').not('.order-close').bind('click', function (e) {
  $('.orders .item').removeClass('active');
  $(this).addClass('active');
});

$('.order-modal .order-close').bind('click', function (e) {
  $('.orders .item').removeClass('active');
  e.stopPropagation();
});
